export const SUPER_USERS = [
    "ruchir.vasavada@novascotia.ca",
    "valerie.cox@novascotia.ca"
];
